import Marquee from "react-fast-marquee";

const items = [
  "No Boundaries",
  "Rent A Car Kohima",
  "Daily & Long-Term",
  "Off-Road Capable",
  "Cars & Bikes",
  "Self-Drive Freedom",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/10 bg-ink py-5" aria-label="Brand keywords" data-testid="editorial-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-serif-ed text-2xl italic text-white/80 md:text-4xl">
              {it}
            </span>
            <span className="h-2 w-2 rotate-45 bg-volt" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
